import { gql } from "@apollo/client";

export const SEND_FOR_INTERPRETATION_WITHOUT_TEMPLATE = gql`
  mutation sendForInterpretationWithoutTemplate(
    $input: SendForInterpretationWithoutTemplateInput!
  ) {
    documentHandler {
      sendForInterpretationWithoutTemplate(input: $input) {
        id
        success
      }
    }
  }
`;
